import type { UserFileRead } from '@/uppy-file-upload/schemas'
import { UserFileProcessingStatus } from '@/user_files/schemas/processing-status'

/** Shown in place of the name of an attached file that has been deleted. */
export const kDeletedFileName = 'Deleted file'

/**
 * Whether an attached file can be opened. A file synced from a connected drive processes again when it changes at the
 * source, so a file that has already been sent can be unopenable again until that finishes.
 */
export function canOpenAttachedFile(file: UserFileRead): boolean {
  return !!file.viewable_content && file.processing_status === UserFileProcessingStatus.Completed
}
